import { useMemo, useState } from "react";
import type { PlaceDTO } from "@shared/types";
import { CATEGORY } from "@/lib/meta";
import { cx, Input } from "../ui";

export function PlaceSelect({
  places,
  value,
  onChange,
  placeholder = "Найти место в поездке…",
}: {
  places: PlaceDTO[];
  value: string | null;
  onChange: (p: PlaceDTO | null) => void;
  placeholder?: string;
}) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const cur = places.find((p) => p.id === value) ?? null;
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return places
      .filter((p) => !s || `${p.name} ${p.nameLocal ?? ""} ${p.region ?? ""}`.toLowerCase().includes(s))
      .sort((a, z) => (a.region ?? "").localeCompare(z.region ?? "") || a.name.localeCompare(z.name))
      .slice(0, 60);
  }, [places, q]);
  return (
    <div className="relative">
      {cur && !open ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex h-10 w-full items-center gap-2 rounded-xl border border-[var(--border)] bg-[var(--surface-2)] px-3 text-left text-sm"
        >
          <span>{CATEGORY[cur.category]?.emoji}</span>
          <span className="min-w-0 flex-1 truncate font-semibold">{cur.name}</span>
          <span className="text-xs text-muted">{cur.region}</span>
        </button>
      ) : (
        <Input autoFocus={open} value={q} placeholder={placeholder} onFocus={() => setOpen(true)} onChange={(e) => setQ(e.target.value)} />
      )}
      {open && (
        <div className="scroll-thin absolute inset-x-0 z-50 mt-1 max-h-64 overflow-y-auto rounded-xl border border-[var(--border)] bg-[var(--surface-solid)] p-1 shadow-[var(--shadow-lg)]">
          <button
            type="button"
            className="w-full rounded-lg px-3 py-2 text-left text-sm text-muted hover:bg-[var(--surface-2)]"
            onClick={() => {
              onChange(null);
              setOpen(false);
              setQ("");
            }}
          >
            — без места —
          </button>
          {list.map((p) => (
            <button
              type="button"
              key={p.id}
              className={cx("flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm hover:bg-[var(--surface-2)]", p.id === value && "bg-[var(--accent-soft)]")}
              onClick={() => {
                onChange(p);
                setOpen(false);
                setQ("");
              }}
            >
              <span>{CATEGORY[p.category]?.emoji}</span>
              <span className="min-w-0 flex-1 truncate font-medium">{p.name}</span>
              <span className="shrink-0 text-xs text-muted">{p.region}</span>
            </button>
          ))}
          {!list.length && <div className="px-3 py-2 text-sm text-muted">Ничего не найдено. Добавьте место через поиск на карте.</div>}
        </div>
      )}
    </div>
  );
}
